let parameters = {
    title: {
        label: 'Title',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        wait: false
    },
    pieType: {
        label: 'Pie Chart',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'parameters.pieType.types',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        types: [
          {id: 'neon', name: 'Neon'},
          {id: 'middle-icon', name: 'Middle Icon'}
        ],
        item: {data: [], headers: []},
        wait: true
    },
    chartDataSource: {
        label: 'Chart Data',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'dataSources',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: true
    },
    titleData: {
        label: 'Title',
        class: 'xs12 sm6',
        type: 'select',
        source: 'parameters.chartDataSource.item.headers',
        itemText: 'text',
        itemValue: 'value',
        items: [],
        item: {data: [], headers: []},
        wait: true
    },
    valueData: {
        label: 'Value',
        class: 'xs12 sm6',
        type: 'select',
        source: 'parameters.chartDataSource.item.headers',
        itemText: 'text',
        itemValue: 'value',
        items: [],
        wait: true
    },
    themeDataSource: {
        label: 'Theme',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'dataSources',
        itemText: 'name',
        itemValue: 'id',
        items: [],
        wait: true
    },
    colorGradient: {
        label: 'ThemeColor',
        class: 'xs12 sm12 d-flex',
        type: 'theme-color',
        source: 'parameters.themeDataSource.item.data',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [],
        wait: true,
        value: null
    }
};

export default parameters;
